import { api } from '../constants/DevProd';
import { Dimensions, Platform } from 'react-native';
import i18n from 'i18n-js';
import * as ImageManipulator from 'expo-image-manipulator';
import * as LocalAthentication from 'expo-local-authentication';
import Storage from '../components/Storage';
import { Notifier, Easing, NotifierComponents } from 'react-native-notifier';

const getAvatarUrl = (userId, version) => {
  // return `${api.base}users/avatar/${userId}?${version}`;
  return `${api.base}users/avatar/${userId}`;
}
const getGovernmentIdUrl = (userId, governmentId, version) => {
  // return `${api.base}users/${userId}/${governmentId}?${version}`;
  return `${api.base}users/${userId}/${governmentId}`;
}
const getAgreementMainImageUrl = (agreementId) => {
  return `${api.base}agreements/${agreementId}/main_images`;
}
const getCompanyLogoImageUrl = (companyId, version) => {
  // return `${api.base}companies/${companyId}/logo?${version}`;
  return `${api.base}companies/${companyId}/logo`;
}
const getCompanyProjectGalleryImageUrl = (companyId, imageId) => {
  return `${api.base}companies/${companyId}/project_gallery/${imageId}`;
}
const getAgreementAdditionalImageUrl = (agreementId, imageId) => {
  return`${api.base}agreements/${agreementId}/additional_images/${imageId}`;
}

const formatPhoneNumber = (n) => {
  n = n.replace(/1 /, '');
  n = n.replace(/\D/g, '');
  let num = '';
  let n1 = n.substring(0, 3);
  let n2 = n.substring(3, 6);
  let n3 = n.substring(6, 10);
  let n4 = n.substring(10);
  if(n1){
    num += '(' + n1;
  }
  if(n2){
    num += ')' + n2;
  }
  if(n3){
    num += '-' + n3;
  }
  if(n4){
    num += 'x' + n4;
  }
  return num;
}
const stripPhoneNumber = (n) => {
  if(!n){ return ''; }
  return n.replace(/\(|\)|-/g, '');
}

const stripNonNumeric = (n) => {
  return n.replace(/\D/g, '');
}

const containerDimensions = (num, index, photoWidth, photoHeight, isScrollable) => {
  // num is number of items per row
  let numMargin = (num - 1) * 10;
  const windowWidth = Platform.OS === 'web' ? (Dimensions.get('window').width > 768 ? 768 : Dimensions.get('window').width) : Dimensions.get('window').width;
  const which = index + 1;
  const width = ((windowWidth - numMargin - 20) / num);
  const margin = (((which % num) === 0) && !isScrollable) ? 0 : 10;
  // console.log('containerdimensions', windowWidth, index, which, width, margin);
  if(photoWidth && photoHeight){
    return {
      width: width,
      height: width,
      marginRight: margin,
      aspectRatio: photoWidth / photoHeight,
    }
  }else{
      return {
      width: width,
      height: width,
      marginRight: margin,
    }
  }
}

const formatAmount = (a) => {
  if(!a) return '';
  // console.log('formatAmount1', a);
  // a = parseFloat(a.replace(/[^0-9.]/g, '')); // allows multiple decimals
  a = String(a).replace(/\$/g, '');
  if(a === ''){ return a; }
  // console.log('formatAmount2', a);
  let counter = 0;
  a = a.replace(/[^0-9.]|\./g, function ($0) {
    // console.log('$0', $0);
    if ($0 == "." && !(counter++)){
      // console.log('counter', counter);
      // dot found and counter is not incremented
      return ".";
    }
    // console.log('erase it');
    // that means we met first dot and we want to keep it
    return ""; // if we find anything else, let's erase it
  });
  // console.log('after replace', a);
  // let dollarSign = String(a).startsWith('$') ? '' : '$';
  if (!a.endsWith('.') && !a.endsWith('$') && !a.endsWith('.0')){
    a = parseFloat(a);
    a = +a.toFixed(2);
  //   console.log('formatAmount3', a, +a.toFixed(2));
  }
  
  // if (addDollarSign){
  //   return String(dollarSign + a);
  // }else{
  //   return String(a);
  // }
  return String(a);
}
const formatPercent = (p) => {
  // console.log('formatPercent1', p);
  if (p === '') { return p; }
  p = String(p).replace(/\%/g, '');
  p = parseInt(String(p).replace(/[^0-9]/g, ''));
  // console.log('formatPercent2', p);
  if(p > 100){
    return String(100);
  }
  return String(p);
}

const formatCurrency = (c) => {
  // console.log('formatCurrency', c);
  if(c === undefined){ return '$0.00'; }
  const isNegative = 
  // c = c.replace(/\$\,/g, '');
  c = String(c).replace(/[^-.0-9]/g, '');
  return i18n.toCurrency(c);
}
const formatPercentDisplay = (p) => {
  console.log('formatPercentDisplay', p);
  if (!p) { return ''; }
  p = p.replace(/\%/g, '');
  return i18n.toPercentage(p, { precision: 0 });
}
// crashes android because of Intl
// const formatAmountDisplay = new Intl.NumberFormat('en-us', {
//   style: 'currency',
//   currency: 'USD',
// });


const processLoginAccount = (user, initial) => {
  console.log('processLoginAccount')
  user.isLoggedIn = initial ? (!user.terms_of_use ? false : true) : true;
  // user.avatar = (user.avatar !== null) ? getAvatarUrl(user.id, user.avatar) : null;
  user.isContractor = (user.company_id) ? true : false;
  let ids = [];
  if(user.government_id1){
    ids.push({
      existing: true,
      uri: getGovernmentIdUrl(user.id, 'government_id1', user.government_id1),
      type: user.government_id1_type,
      version: user.government_id1,
      existing: true,
    });
  }
  if (user.government_id2) {
    ids.push({
      existing: true,
      uri: getGovernmentIdUrl(user.id, 'government_id2', user.government_id2),
      type: user.government_id2_type,
      version: user.government_id2,
      existing: true,
    });
  }
  user.photoIds = ids;
  // user.isContractor = true;
  console.log('processLoginAccount', user)
  Storage.setItem('user', JSON.stringify(user));
  return user;
}

const getImageFieldsForUpload = (uri) => {
  let filename = uri.split('/').pop();
  // Infer the type of the image
  let match = /\.(\w+)$/.exec(filename);
  let type = match ? `image/${match[1]}` : `image`;

  return { filename: filename, type: type };
};

const splitFullName = (name) => {
  return name.split(' ');
}

const manipulateImage = async (image, width, height) => {
  // not working properly on android
  if(Platform.OS === 'android'){ return image; }
  console.log('manipulate image: ', image);
  const ratio1 = width / height;
  const ratio2 = height / width;
  const imgRatio1 = image.width / image.height;
  const imgRatio2 = image.height / image.width;
  let newHeight = 0;
  let newWidth = 0;
  let originY = 0;
  let originX = 0;
  console.log('ratios: ', ratio1, ratio2, imgRatio1, imgRatio2);
  if ((image.width / image.height) !== ratio1) {
    console.log(`image must be manipulated to ${width}:${height}`);
    if(ratio1 === 1){
      console.log('square...');
      // square image
      if(image.width > image.height){
        console.log('width > height');
        newWidth = image.height;
        newHeight = image.height;
        originX = (image.width - image.height) / 2;
      }else{
        console.log('width < height');
        newHeight = image.width;
        newWidth = image.width;
        originY = (image.height - image.width) / 2;
      }
    }else if(ratio1 > 1){
      console.log('landscape...');
      // landscape
      if(imgRatio1 > ratio1){
        console.log('adjust width');
        newWidth = image.height * ratio1;
        newHeight = image.height;
        originX = (image.width - newWidth) / 2;
      }else if(imgRatio1 < ratio1){
        console.log('adjust height');
        newHeight = image.width * ratio2;
        newWidth = image.width;
        originY = (image.height - newHeight) / 2;
      }
    }else if(ratio < 1){
      console.log('portrait...');
      // portrait
      if(imgRatio1 > ratio1){
        console.log('adjust width');
        newWidth = image.height * ratio1;
        newHeight = image.height;
        originX = (image.width - newWidth) / 2;
      }else if(imgRatio1 < ratio1){
        console.log('adjust height');
        newHeight = image.width * ratio2;
        newWidth = image.width;
        originY = (image.height - newHeight) / 2;
      }
    }
    
    console.log(`about to resize: originX: ${originX}, originY: ${originY}, newWidth: ${newWidth}, newHeight: ${newHeight}`);
    console.log('ratios2: ', newWidth / newHeight, newHeight / newWidth);
    const result = await ImageManipulator.manipulateAsync(
      image.localUri || image.uri,
      [{
        crop: {
          originX: originX,
          originY: originY,
          width: newWidth,
          height: newHeight,
        }
      }],
      { compress: 1, format: ImageManipulator.SaveFormat.JPEG }
    );
    console.log(`manipulated image to ${width}:${height} `, result);
    // return result;
    return resizeImage(result, width, height);
  }
  return image;
}

const resizeImage = async (image, width, height) => {
  console.log(`resize image to ${width} x ${height}`);
  console.log('resize image: ', image);
  // let resize = { width: width };
  // if(image.width > image.height){
  //   resize = { height: height }
  // }
  // removed the following line, was causing an error on web after updates to sdk 47
  // let uri = Platform.OS === 'web' ? image.base64 : image.uri;
  const result = await ImageManipulator.manipulateAsync(
    image.uri,
    [{
      // resize: resize
      resize: { width: width, height: height }
    }],
    { compress: 1, format: ImageManipulator.SaveFormat.JPEG }
  )
  console.log('resizedImage: ', result);
  return result;
};

const isLocalAuthenticationAvailable = async () => {
  console.log('isLocalAuthenticationAvailable');
  if(Platform.OS !== 'web'){
    let hasHardwareAsync = await LocalAthentication.hasHardwareAsync();
    if (hasHardwareAsync) {
      let supportedAuthenticationTypesAsync = await LocalAthentication.supportedAuthenticationTypesAsync();
      console.log('supportedAuthenticationTypesAsync', supportedAuthenticationTypesAsync);
      if (supportedAuthenticationTypesAsync.length !== 0) {
        // getLocalAuthenticationMessage(supportedAuthenticationTypesAsync);
        let isEnrolledAsync = await LocalAthentication.isEnrolledAsync();
        if (isEnrolledAsync) {
          console.log('localAuthentication: true');
          return true;
        }
      }
    }
  }
  console.log('localAuthentication: false');
  return false;
}

const dataUrlToFile = async (dataUrl, fName) => {
  // console.log('dataUrlToFile: ', dataUrl);
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  const type = dataUrl.split(',')[0].split(':')[1].split(';')[0];
  const ext = `.${type.split('/')[1]}`;
  const fileName = fName !== undefined ? `${fName}${ext}` : `webimage${Math.floor(Math.random(10000) * 10000)}${ext}`;
  const file = new File([blob], fileName, { type: type });
  console.log('file: ', file);
  return file;
}

const showAlert = (type, message, onHidden) => {
  console.log('showAlert: ', type, message, onHidden);
  let types = ['error', 'success', 'warn', 'info'];
  type = types.includes(type) ? type : 'info';
  let options = {
    title: message,
    duration: 2300,
    animationDuration: 800,
    showEasing: Easing.bounce,
    hideOnPress: true,
    Component: NotifierComponents.Alert,
    componentProps: {
      alertType: type,
      titleStyle: { fontSize: 20 }
    },
  };
  if(onHidden){ options.onHidden = onHidden; }
  Notifier.showNotification(options);
}
const showNotification = (title, message, onHidden) => {
  let options = {
    duration: 2300,
    animationDuration: 800,
    showEasing: Easing.bounce,
    hideOnPress: true,
    Component: NotifierComponents.Notification,
    componentProps: {
      titleStyle: { fontSize: 20 }
    },
  };
  if(title){ options.title = title; }
  if(message){ options.description = title; }
  if(onHidden) { options.onHidden = onHidden; }
  Notifier.showNotification(options);
}

const getFileExtension = (filename) => {
  console.log('getFileExtension: ', filename);
  return filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;
}

const getFileNameFromPath = (path) => {
  console.log('getFileName: ', path);
  return path.substring(path.lastIndexOf('/') + 1, path.length) || path;
}

const isImageExtensionValid = (filename) => {
  const validExtensions = ['jpg', 'jpeg', 'png', 'webp', 'heic', 'gif'];
  const extension = getFileExtension(filename).toLowerCase();
  console.log('isImageExtensionValid: ', validExtensions, extension);
  return {
    result: validExtensions.includes(extension),
    extensions: validExtensions.map(e => { return `.${e}`; }).join(', '),
  }
}

export {
  getAvatarUrl,
  getAgreementMainImageUrl,
  getAgreementAdditionalImageUrl,
  getCompanyLogoImageUrl,
  getCompanyProjectGalleryImageUrl,
  formatPhoneNumber,
  stripPhoneNumber,
  stripNonNumeric,
  containerDimensions,
  formatAmount,
  formatCurrency,
  formatPercent,
  formatPercentDisplay,
  processLoginAccount,
  getImageFieldsForUpload,
  splitFullName,
  manipulateImage,
  resizeImage,
  isLocalAuthenticationAvailable,
  dataUrlToFile,
  showAlert,
  showNotification,
  getFileExtension,
  getFileNameFromPath,
  isImageExtensionValid,
}